import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Button } from 'ui-components/components/button';
import { noop } from 'ui-components/default-props/noop';

import style from './edit-columns-button.module.less';

const ButtonText = <FormattedMessage defaultMessage='Columns' description='editColumnsButton.columns' id='67yNxO' />;

const EditColumnsButton = ({ onClick = noop }) => {
  return (
    <Button className={style['edit-columns-button']} onClick={onClick} theme='ghost'>
      {ButtonText}
    </Button>
  );
};

EditColumnsButton.propTypes = {
  onClick: PropTypes.func,
};

export default EditColumnsButton;
